import * as React from 'react';
import styled from 'styled-components';
import { Image } from './Image';
import { Link } from 'react-router-dom';
import { EmailIcon } from '../icons/Email';

interface IBrokerItem {
  name: string;
  title: string;
  office: string;
  phone: string;
  path: string;
  image: string;
  showImage?: boolean;
}

export const BrokerItem: React.FC<IBrokerItem> = React.memo(
  ({ name, image, title, office, phone, path = '/', showImage = true }) => {
    return (
      <StyledBrokerItem>
        {showImage === true ? (
          <StyledBrokerImageLink as="a" href={path}>
            <Image size="large" url={image} />
          </StyledBrokerImageLink>
        ) : null}
        <StyledBrokerItemContent>
          {name ? (
            <StyledBrokerName className="name" as="a" href={path}>
              {name}
            </StyledBrokerName>
          ) : null}
          {title ? <span className="title">{title}</span> : null}
          {office ? (
            <span className="office">PrivatMegleren {office}</span>
          ) : null}
          {phone ? (
            <span className="contact-info">
              <span className="phone">
                <a href={`tel:${phone.replace(/ /g, '')}`}>{phone}</a>
              </span>
              <a href={`${path}/kontakt`}>
                <EmailIcon className="email-icon" />
              </a>
            </span>
          ) : null}
        </StyledBrokerItemContent>
      </StyledBrokerItem>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.image === nextProps.image) {
      return true;
    }
    return false;
  }
);

const StyledBrokerItem = styled.div`
  display: flex;
  width: 100%;
  flex-flow: column;
  align-items: center;
  margin-bottom: 20px;
  float: left;
  text-decoration: none;

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledBrokerName = styled((props) => <Link {...props} />)`
  padding: 1rem 0;
  font-size: 1.1875rem;
  color: ${(props) => props.theme.colors.primary};
  text-decoration: none;
`;

const StyledBrokerImageLink = styled((props) => <Link {...props} />)``;

const StyledBrokerItemContent = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: 0.625rem 0 0 0;
  text-align: center;

  span {
    &.title {
      font-size: 0.75rem;
      color: white;
    }
    &.office {
      margin-top: 10px;
      font-size: 0.75rem;
      color: white;
    }
    &.contact-info {
      display: flex;
      justify-content: center;
      padding: 1rem 0 0 0;

      .email-icon {
        margin-left: 20px;
        float: left;
      }
    }
    &.phone {
      float: left;
      a {
        text-decoration: none;
      }
    }
  }
`;
